var _rect, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 3,
    fill: "#00579F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_847_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2335 13.06H12.6943L13.657 7.10742H15.1961L14.2335 13.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8128 7.25343C19.5092 7.13298 19.0277 7 18.4323 7C16.9124 7 15.842 7.81052 15.8355 8.96933C15.8228 9.82429 16.6018 10.2992 17.1844 10.5842C17.7799 10.8755 17.9823 11.0657 17.9823 11.3253C17.9762 11.7241 17.5011 11.9079 17.058 11.9079C16.4435 11.9079 16.1142 11.8131 15.6139 11.5913L15.4112 11.4962L15.1958 12.8324C15.5568 12.9969 16.2219 13.1428 16.9124 13.1492C18.5274 13.1492 19.5788 12.3512 19.5912 11.1163C19.5974 10.4387 19.186 9.91948 18.2993 9.4952C17.7609 9.22284 17.4313 9.03918 17.4313 8.76051C17.4376 8.50717 17.7101 8.24768 18.3178 8.24768C18.8182 8.23497 19.1858 8.35525 19.4643 8.47561L19.6035 8.53882L19.8128 7.25343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8589 10.9512C21.9856 10.6093 22.4734 9.28573 22.4734 9.28573C22.467 9.29844 22.5999 8.93745 22.6759 8.71584L22.7834 9.22875C22.7834 9.22875 23.0749 10.6536 23.1382 10.9512C22.8976 10.9512 22.1629 10.9512 21.8589 10.9512ZM23.7587 7.10742H22.5682C22.2011 7.10742 21.9222 7.21499 21.7638 7.60131L19.4775 13.0599H21.0925C21.0925 13.0599 21.3584 12.3252 21.4156 12.167C21.5927 12.167 23.1638 12.167 23.3917 12.167C23.4359 12.376 23.5754 13.0599 23.5754 13.0599H25.0005L23.7587 7.10742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4089 7.10742L9.90158 11.1665L9.73687 10.3433C9.45819 9.39338 8.58421 8.36133 7.60889 7.84817L8.98955 13.0537H10.6172L13.0364 7.10742H11.4089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50168 7.10742H6.02533L6 7.2277C7.9317 7.72167 9.21103 8.91237 9.73665 10.3435L9.19832 7.60779C9.1097 7.22761 8.83733 7.11996 8.50168 7.10742Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_847_1728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0002,
    height: 6.1492,
    fill: "white",
    transform: "translate(6 7)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.32770c6b980f0e2c6d8fae19b923b02c.svg";
export { ForwardRef as ReactComponent };